import {
	setLoginFlowGlobalStateActionCallbackUrlThunk,
	setLoginFlowGlobalStateActionSignInThunk,
	setLoginFlowGlobalStateActionSignOutThunk,
	setLoginFlowGlobalStateActionSignUpThunk,
	setLoginFlowGlobalStateModalOpenThunk,
	setLoginFlowGlobalStateStageTriggerSourceThunk,
	setLoginFlowGlobalStateUiTypeThunk,
	setLoginFlowGlobalStateUserCountryCodeThunk,
	setLoginFlowGlobalStateUserHasReferralCodeThunk,
	setLoginFlowGlobalStateUserPhoneThunk,
	setLoginFlowGlobalStateUserReferralCodeThunk,
} from "../../../redux-magic/store";

export type LoginFlowProps = {
	dispatch: Function;
	trigger_source?: string;
	autofill?: boolean;
	flow_type?: "modal" | "redirect";
	action?: {
		callback_url: string;
		sign_in: (session: any) => void;
		sign_up: (session: any) => void;
		sign_out: () => void;
	};
	user?: {
		country_code: string;
		phone: string;
		has_referral_code: boolean;
		referral_code: string;
	};
};

export type LoginFlowTriggers = {
	startFlow: () => void;
	resetFlow: () => void;
};

const createLoginFlow: (loginFlowProps: LoginFlowProps) => LoginFlowTriggers = ({
	dispatch,
	trigger_source = "default_redux_state",
	autofill = false,
	flow_type = "modal",
	action: { callback_url, sign_in, sign_up, sign_out } = {
		callback_url: "https://beegru.com/en-IN/",
		sign_in: (session: any) => {},
		sign_up: (session: any) => {},
		sign_out: () => {},
	},
	user: { country_code, phone, has_referral_code, referral_code } = {
		country_code: "+91",
		phone: "",
		has_referral_code: false,
		referral_code: "",
	},
}: LoginFlowProps) => {
	dispatch(setLoginFlowGlobalStateUiTypeThunk(flow_type));
	dispatch(setLoginFlowGlobalStateStageTriggerSourceThunk(trigger_source));
	dispatch(setLoginFlowGlobalStateActionCallbackUrlThunk(callback_url));
	dispatch(setLoginFlowGlobalStateActionSignInThunk(sign_in));
	dispatch(setLoginFlowGlobalStateActionSignUpThunk(sign_up));
	dispatch(setLoginFlowGlobalStateActionSignOutThunk(sign_out));
	if (autofill) {
		dispatch(setLoginFlowGlobalStateUserCountryCodeThunk(country_code));
		dispatch(setLoginFlowGlobalStateUserPhoneThunk(phone));
		dispatch(setLoginFlowGlobalStateUserHasReferralCodeThunk(has_referral_code));
		dispatch(setLoginFlowGlobalStateUserReferralCodeThunk(referral_code));
	}
	return {
		startFlow: () => {
			dispatch(setLoginFlowGlobalStateModalOpenThunk(true));
		},
		resetFlow: () => {
			dispatch(setLoginFlowGlobalStateModalOpenThunk(false));
			dispatch(setLoginFlowGlobalStateUiTypeThunk("modal"));
			dispatch(setLoginFlowGlobalStateStageTriggerSourceThunk("default_redux_state"));
			dispatch(setLoginFlowGlobalStateUserCountryCodeThunk("+91"));
			dispatch(setLoginFlowGlobalStateUserPhoneThunk(""));
			dispatch(setLoginFlowGlobalStateUserHasReferralCodeThunk(false));
			dispatch(setLoginFlowGlobalStateUserReferralCodeThunk(""));
			dispatch(setLoginFlowGlobalStateActionCallbackUrlThunk("https://beegru.com/en-IN/"));
			dispatch(setLoginFlowGlobalStateActionSignInThunk(() => {}));
			dispatch(setLoginFlowGlobalStateActionSignUpThunk(() => {}));
			dispatch(setLoginFlowGlobalStateActionSignOutThunk(() => {}));
		},
	};
};

export default createLoginFlow;
